import { Phone } from "lucide-react";
import { CONTACT_NAME, CONTACT_DISPLAY_PHONE } from "./kursusConstants";

export function KursusFooter() {
  return (
    <footer data-testid="kursus-footer" className="bg-kursus-bg border-t-2 border-kursus-gold/50 py-10">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="font-anton uppercase text-xl text-kursus-white mb-1">BODYGUARD SARAWAK</p>
        <p className="text-xs text-kursus-muted mb-6">Persatuan Pengawal Peribadi Sarawak</p>

        <p className="font-oswald text-sm text-kursus-gold tracking-wide mb-6">KURSUS ASAS PENGAWAL PERIBADI</p>

        <div className="flex items-center justify-center gap-2 text-kursus-white text-sm">
          <Phone className="w-3.5 h-3.5 text-kursus-gold" /> {CONTACT_NAME} — {CONTACT_DISPLAY_PHONE}
        </div>
      </div>
    </footer>
  );
}
